<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'

const { position = 'right', type = 'card' } = defineProps<{
  position?: 'right' | 'left'
  type?: 'card' | 'list' | 'banner'
  label?: string
}>()

const { t } = useI18n()

const containerClasses = computed(() => ({
  'right-px top-px': position === 'right' && type === 'list',
  'right-0 top-0': position === 'right' && type === 'card',
  'left-px top-px': position === 'left' && type === 'list',
  'left-0 top-0': position === 'left' && type === 'card',
  '-right-5 -top-3': type === 'banner',
}))

const badgeClasses = computed(() => ({
  'rounded-r-md': position === 'right' && type !== 'banner',
  'rounded-l-md': position === 'left' && type !== 'banner',
  'border-l-[64px] border-t-[64px] border-l-transparent': position === 'right',
  'border-r-[64px] border-t-[64px] border-r-transparent': position === 'left',
}))

const textClasses = computed(() => ({
  'left-[16px] top-[-14px] rotate-45': position === 'right',
  'right-[16px] top-[-14px] -rotate-45': position === 'left',
}))
</script>

<template>
  <aside class="pointer-events-none absolute z-20" :class="containerClasses">
    <div class="border-t-yellow-40 size-0 border-transparent" :class="badgeClasses" />
    <span
      class="text-seagreen-40 absolute inset-0 grid place-items-center text-xs font-semibold tracking-wider uppercase select-none"
      :class="textClasses"
      v-text="label ?? t('share.options.homework')"
    />
  </aside>
</template>
